import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/cn";
/**
 * The brand's `.note` box: a tinted panel at 7% of one accent with a 38%
 * border of the same accent and a mono uppercase title.
 *
 * `role` matters more than it looks. A message that appears in response to
 * something the user just did needs to be announced, and a static piece of
 * page furniture must not be. The default is `status` (polite); pass
 * `role="alert"` for something that interrupts, and nothing at all for a
 * note that was on the page before the user arrived.
 */
export const alertVariants = cva(["lg:relative lg:w-full lg:rounded-md lg:border lg:px-5 lg:py-4"], {
    variants: {
        tone: {
            warning: "lg:border-warning/40 lg:bg-warning/[0.07] lg:[&_[data-slot=alert-title]]:text-warning",
            danger: "lg:border-destructive/40 lg:bg-destructive/[0.07] lg:[&_[data-slot=alert-title]]:text-destructive",
            info: "lg:border-info/40 lg:bg-info/[0.07] lg:[&_[data-slot=alert-title]]:text-info",
            success: "lg:border-success/40 lg:bg-success/[0.07] lg:[&_[data-slot=alert-title]]:text-success",
            neutral: "lg:border-hairline lg:bg-card lg:[&_[data-slot=alert-title]]:text-strong",
        },
    },
    defaultVariants: { tone: "warning" },
});
export function Alert({ className, tone, role = "status", ...props }) {
    return (_jsx("div", { "data-slot": "alert", role: role, className: cn(alertVariants({ tone }), className), ...props }));
}
export function AlertTitle({ className, ...props }) {
    return (_jsx("p", { "data-slot": "alert-title", className: cn("lg:font-label lg:text-eyebrow lg:font-medium lg:uppercase lg:tracking-[0.12em] lg:mb-2", className), ...props }));
}
export function AlertDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-description", className: cn("lg:text-body-sm lg:text-muted-foreground lg:[&_p]:max-w-none", className), ...props }));
}
//# sourceMappingURL=alert.js.map